import React from 'react'
import { useTranslation } from 'react-i18next'
import { Text } from '@node-space/ui-components'
import { useAccountsContext } from 'hooks/context/useAccountsContext'

export const LoginFooter = () => {
  const { t } = useTranslation()
  const { shouldShowUKInfoBanner } = useAccountsContext()

  return (
    <>
      {shouldShowUKInfoBanner && (
        <Text variant="body-text" color="subdued" isCentered className="mt-auto pb-3">
          {t('ukApprovalStamp')}
        </Text>
      )}
      <Text variant="caption-text" color="subdued" isCentered className="mt-auto pb-4">
        {`${t('recaptcha.protected')}`}
        <br />© 2017 - {new Date().getFullYear()} BVNK. {`${t('allRightsReserved')}`}
      </Text>
    </>
  )
}
